import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "myrdp_cookie_consent_v1";

export default function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!window.localStorage.getItem(STORAGE_KEY)) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const save = (value) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-[100] px-4 pb-4 pt-2 sm:px-6 sm:pb-6 pointer-events-none"
      role="dialog"
      aria-label="Cookie consent"
      aria-live="polite"
    >
      <div
        className="pointer-events-auto mx-auto flex max-w-4xl flex-col gap-4 rounded-2xl border border-[#EBEBEB1C] bg-[#0D0C0F]/95 px-4 py-4 shadow-[0_-8px_40px_rgba(0,0,0,0.45)] backdrop-blur-[20px] sm:flex-row sm:items-center sm:justify-between sm:px-6 sm:py-5"
        style={{ boxShadow: "inset 0 1px 0 rgba(255,255,255,0.06), 0 -12px 48px rgba(0,0,0,0.5)" }}
      >
        <div className="min-w-0 flex-1 space-y-2 text-sm leading-relaxed text-[#E7E7E7]/90">
          <p className="font-medium text-white">Cookies &amp; privacy</p>
          <p className="text-[#A2ADB5]">
            We use cookies and similar technologies to run the site, keep you signed in, remember preferences, and
            understand how our pages are used. By clicking <span className="text-white/90">Accept</span>, you agree to
            our use of cookies as described in our{" "}
            <Link to="/privacy" className="text-[#486FFF] underline underline-offset-2 hover:text-[#7c9cff]">
              Privacy Policy
            </Link>
            .
          </p>
        </div>
        <div className="flex flex-shrink-0 flex-wrap items-center gap-2 sm:flex-col sm:items-stretch md:flex-row">
          <button
            type="button"
            onClick={() => save("essential")}
            className="rounded-xl border border-white/15 bg-white/5 px-4 py-2.5 text-sm font-medium text-white/90 transition-colors hover:bg-white/10"
          >
            Essential only
          </button>
          <button
            type="button"
            onClick={() => save("accepted")}
            className="rounded-xl bg-gradient-to-b from-[#3b5cff] to-[#2333FF] px-5 py-2.5 text-sm font-semibold text-white shadow-[0_4px_20px_rgba(35,51,255,0.35)] transition-transform hover:-translate-y-0.5"
          >
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
}
